module.exports = __webpack_public_path__ + "media/images/emblems/Sembrancher-bf7ebbeb3d8d314601c93f490ea81d19.png";